<template>
	<li v-if="availableLocales.length > 0">
		<div class="side-nav-language-switcher">
			<select
				class="side-nav-language-switcher__select link"
				name="language"
				id="language"
				v-model="switcher"
				:aria-label="label"
			>
				<option :value="locale" disabled selected>
					{{ label }} {{ currentLang }}
				</option>
				<option
					v-for="(l, index) in availableLocales"
					:key="`language-switcher-${index}`"
					:value="l.code"
				>
					{{ l.label }}
				</option>
			</select>
			<SvgIcon
				class="side-nav-language-switcher__arrow-down"
				icon="arrowdown"
			/>
		</div>
	</li>
</template>

<script setup>
const store = useAppStore();
const props = defineProps({
	label: { type: String, required: false, default: "" },
});

const { locales, locale } = useI18n();
const currentLang = useLangCodeTranslated(locale.value);
const switcher = ref(locale.value);
const switchLocalePath = useSwitchLocalePath();

const availableLocales = computed(() => {
	return locales.value
		.filter((l) => l.code !== locale.value)
		.map((l) => {
			return {
				label: useLangCodeTranslated(l.code),
				code: l.code,
			};
		});
});

watch(
	() => switcher.value,
	(l) => {
		navigateTo(switchLocalePath(l));
		store.closeSideNav();
	}
);
</script>

<style lang="scss">
.side-nav-language-switcher {
	position: relative;
	display: inline-block;

	.side-nav-language-switcher__select {
		border: none;
		-moz-appearance: none;
		-webkit-appearance: none;
		background-color: transparent;
		transition: all 200ms ease;
		line-height: 1.2;

		&:focus {
			outline: none;
		}

		&::-ms-expand {
			display: none;
		}
	}

	.side-nav-language-switcher__arrow-down {
		pointer-events: none;
		position: absolute;
		right: 15px;
		top: calc(50% - 7px);
		width: 15px;
		height: 15px;

		path {
			stroke: var(--primary-colours-fades-night-sky-50, rgba(25, 26, 26, 0.5));
			transition: all 300ms ease;
		}
	}
}
</style>
